import { TrackProperties } from "./../../../pages/DAW/types";
import { useEffect, useState } from "react";
import { InstrumentTrackProperties } from "../../../pages/DAW/types";
import { StepType } from "../../../reactronica";
import { SelectChangeEvent } from "@mui/material";

type ReturnType = {
  track: InstrumentTrackProperties;
  updateTrackSteps: (steps: StepType[]) => void;
  handleNameChange: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  handleMuteChange: () => void;
  handleSoloChange: () => void;
  handlePanChange: (newValue: number) => void;
  handleInstrumentTypeChange: (event: SelectChangeEvent<string>) => void;
  handleVolumeChange: (newValue: number) => void;
  handleEffectChange: (event: SelectChangeEvent<string>) => void;
};

const useInstrumentTrack = (trackProperties: TrackProperties): ReturnType => {
  const [track, setTrack] = useState<InstrumentTrackProperties>({
    ...trackProperties,
    steps: [],
    instrument: {
      type: "synth",
    },
  });

  useEffect(() => {
    if (trackProperties.trackFinished !== track.trackFinished)
      setTrack((prev) => ({
        ...prev,
        trackFinished: trackProperties.trackFinished,
      }));
  }, [track.trackFinished, trackProperties.trackFinished]);

  const updateTrackSteps = (steps: StepType[]) => {
    setTrack((prev) => ({ ...prev, steps }));
  };

  const handleNameChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setTrack((prev) => ({ ...prev, name: event.target.value }));
  };

  const handlePanChange = (newValue: number) => {
    setTrack((prev) => ({ ...prev, pan: newValue / 100 }));
  };

  const handleMuteChange = () => {
    setTrack((prev) => ({ ...prev, mute: !prev.mute }));
  };

  const handleSoloChange = () => {
    setTrack((prev) => ({ ...prev, solo: !prev.solo }));
  };

  const handleVolumeChange = (newValue: number) => {
    let modifiedValue: number;
    if (newValue < 0) modifiedValue = 0;
    else if (newValue > 100) modifiedValue = 100;
    else modifiedValue = Math.round(newValue);
    setTrack((prev) => ({ ...prev, volume: modifiedValue }));
  };

  const handleEffectChange = (event: SelectChangeEvent<string>) => {
    setTrack((prev) => ({
      ...prev,
      effects: (event.target.value + "")
        .split(",")
        .map((v: string) => ({ type: v })),
    }));
  };

  const handleInstrumentTypeChange = (event: SelectChangeEvent<string>) => {
    setTrack((prev) => ({
      ...prev,
      instrument: { ...prev.instrument, type: event.target.value },
    }));
  };

  return {
    track,
    updateTrackSteps,
    handleNameChange,
    handleInstrumentTypeChange,
    handlePanChange,
    handleMuteChange,
    handleSoloChange,
    handleVolumeChange,
    handleEffectChange,
  };
};

export default useInstrumentTrack;
